"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import type { ReactNode } from "react";
import { Fragment } from "react";
import useHasTouchInput from "@/hooks/useHasTouchInput";
export default function CommonDropdownItemsMobileWrapper(t0) {
  const $ = _c(24);
  const {
    isOpen,
    setOpen,
    label,
    hideOnDesktopHover: t1,
    children
  } = t0;
  const hideOnDesktopHover = t1 === undefined ? true : t1;
  const hasTouchInput = useHasTouchInput();
  const shouldHideOnDesktopHover = hideOnDesktopHover && !hasTouchInput;
  const t2 = `tailwind-scope tw-absolute tw-z-[1000] ${shouldHideOnDesktopHover ? "lg:desktop-hover:tw-hidden" : ""}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TransitionChild as={Fragment} enter="tw-duration-300 tw-ease-in-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-300 tw-ease-in-out" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-iron-600/60 tw-transition-opacity" /></TransitionChild>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== setOpen) {
    t4 = () => setOpen(false);
    $[1] = setOpen;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <TransitionChild as={Fragment} enter="tw-duration-300 tw-ease-in-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-300 tw-ease-in-out" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-absolute -tw-top-16 tw-right-0 -tw-ml-8 tw-flex tw-pr-2 tw-pt-4 sm:-tw-ml-10 sm:tw-pr-4"><button type="button" title="Close panel" aria-label="Close panel" className="tw-relative tw-rounded-md tw-border-none tw-bg-transparent tw-p-2.5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white" onClick={t4}>{t5}</button></div></TransitionChild>;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      maxHeight: "calc(100vh - 8rem)",
      paddingBottom: "env(safe-area-inset-bottom,0px)"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== label) {
    t8 = label && <div className="tw-px-6"><DialogTitle className="tw-text-base tw-font-semibold tw-text-iron-50">{label}</DialogTitle></div>;
    $[7] = label;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== children) {
    t9 = <div className="tw-relative tw-mt-3 tw-flex tw-flex-1 tw-flex-col tw-gap-y-6 tw-px-4 sm:tw-px-6"><ul className="tw-mx-0 tw-mb-0 tw-flex tw-list-none tw-flex-col tw-space-y-3 tw-pl-0">{children}</ul></div>;
    $[9] = children;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <div className="tw-flex tw-scroll-py-3 tw-flex-col tw-overflow-y-auto tw-rounded-t-xl tw-bg-iron-950 tw-pt-6" style={t7}>{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6) {
    t11 = <div className="tw-fixed tw-inset-0 tw-overflow-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><TransitionChild as={Fragment} enter="tw-transform tw-transition tw-duration-300 tw-ease-out" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-duration-300 tw-ease-in" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><DialogPanel className="tw-pointer-events-auto tw-relative tw-w-screen tw-transform-gpu">{t6}{t10}</DialogPanel></TransitionChild></div></div></div>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== setOpen || $[18] !== t11 || $[19] !== t2) {
    t12 = <Dialog as="div" className={t2} onClose={setOpen}>{t3}{t11}</Dialog>;
    $[17] = setOpen;
    $[18] = t11;
    $[19] = t2;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isOpen || $[22] !== t12) {
    t13 = <Transition show={isOpen} as={Fragment}>{t12}</Transition>;
    $[21] = isOpen;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}